import { render, staticRenderFns } from "./editor_textContext.vue?vue&type=template&id=352b8830&scoped=true"
import script from "./editor_textContext.vue?vue&type=script&lang=js"
export * from "./editor_textContext.vue?vue&type=script&lang=js"
import style0 from "./editor_textContext.vue?vue&type=style&index=0&id=352b8830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352b8830",
  null
  
)

export default component.exports